"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSClientOnlyEntity = void 0;
const CSEntity_1 = require("../entity/CSEntity");
class CSClientOnlyEntity extends CSEntity_1.CSEntity {
    constructor(manifest, instanceID, initialState, initialLocalStore, animationManager) {
        super(manifest, instanceID, initialLocalStore, animationManager);
        this._manifest = manifest;
        this._entityState = initialState;
    }
    setState(key, value, animation) {
        // Client-only entity, so there's no server we need to worry about contacting.
        this._entityState[key] = value;
        if (animation) {
            // TODO FIXME
            this.animationManager.queueAnimation(this, animation);
        }
    }
    get manifest() {
        return this._manifest;
    }
}
exports.CSClientOnlyEntity = CSClientOnlyEntity;
//# sourceMappingURL=CSClientOnlyEntity.js.map